import styled from 'styled-components';
import { Container, ContainerContentStandard } from '../../../../../shared/styles/container';
import { Headline } from '../../../../../shared/styles/headline';
import { SubcategoryTagReadOnly } from '../../../../../shared/styles/tag';
import { enumKeys } from '../../../../../shared/utils/enumkeys';
import { Discipline } from '../../../model/talentpool/discipline';

const SubcategoryTagsCentered = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    position: relative;
    column-gap: 8px;
    row-gap: 8px;
`;

export const TagCloud = () => {
    return (
        <Container centered>
            <ContainerContentStandard>
                <Headline>
                    Wir haben <span>Talente</span> für jedes Gebiet
                </Headline>
                <SubcategoryTagsCentered>
                    {enumKeys(Discipline).map((key: keyof typeof Discipline, index) => (
                        <SubcategoryTagReadOnly key={key + index}>
                            {Discipline[key]}
                        </SubcategoryTagReadOnly>
                    ))}
                </SubcategoryTagsCentered>
            </ContainerContentStandard>
        </Container>
    )
}
